package org.dronda.app.web.repository

import kotlinx.browser.window
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

object ClientStorageRepository {
    val serializer = Json { ignoreUnknownKeys = true }

    inline fun <reified T> getItem(key: String): T? {
        return window.localStorage.getItem(key)?.let {
            kotlin.runCatching {
                serializer.decodeFromString<T>(it)
            }.getOrNull()
        }
    }

    inline fun <reified T> storeItem(key: String, value: T) {
        LocalStorage.storeInLocalStorage(key, value)
    }
    fun clearItem(key: String) {
        LocalStorage.clearPairInLocalStorage(key)
    }

    object LocalStorage {
        fun clearPairInLocalStorage(key: String) {
            window.localStorage.removeItem(key)
        }
        inline fun <reified T> storeInLocalStorage(key: String, value: T) {
            kotlin.runCatching {
                serializer.encodeToString(value)
            }.onFailure {
                println("Failed to serialize for local storage")
            }.getOrNull()?.let { body ->
                window.localStorage.setItem(key, body)
            }
        }
    }
}
